import { Investor } from './investor';
import { Manager } from './manager';

export const ProgressBar = {
  Investor,
  Manager,
};
